import React, { Component } from 'react';
import PropTypes from 'prop-types';

import hostedInLuxembourgLogo from 'assets/images/hosted_in_luxembourg_logo.svg';
import madeInLuxembourgLogo from 'assets/images/made_in_luxembourg_logo.svg';
import zapLogo from 'assets/images/zap_logo.svg';

import LanguageForm from 'modules/Language/LanguageForm';

class FooterView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="footer-container" id="footer">
        <div className="container u-max-size">
          <div className="company-infos">
            <LanguageForm />
            <div className="infos-section">
              <div>{this.props.translations['footer.getInTouch']}</div>
              <div>
                <a href="tel:00352260931">+352 26 09 31</a>
              </div>
            </div>
            <div className="infos-section">
              <div>{this.props.translations['footer.office']}</div>
              <div>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/41+Rue+du+puits+Romain,+8070+Bertrange/@49.6073353,6.0780272,18z/data=!4m5!3m4!1s0x4795495148c34cf7:0x42fb2184bfcda1d3!8m2!3d49.6073367!4d6.079309"
                >
                  ZAP S.A.
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/41+Rue+du+puits+Romain,+8070+Bertrange/@49.6073353,6.0780272,18z/data=!4m5!3m4!1s0x4795495148c34cf7:0x42fb2184bfcda1d3!8m2!3d49.6073367!4d6.079309"
                >
                  41, Rue du Puits Romain
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/41+Rue+du+puits+Romain,+8070+Bertrange/@49.6073353,6.0780272,18z/data=!4m5!3m4!1s0x4795495148c34cf7:0x42fb2184bfcda1d3!8m2!3d49.6073367!4d6.079309"
                >
                  L-8070 Bertrange
                </a>
              </div>
            </div>
            <div className="infos-section">
              <div>{this.props.translations['footer.headquarter']}</div>
              <div>ZAP S.A.</div>
              <div>35A, Avenue John F. Kennedy</div>
              <div>L-1855 Luxembourg</div>
            </div>
          </div>
          <div className="footer-logos">
            <div className="logos-container">
              <div>
                <a target="_blank" rel="noopener noreferrer" href="https://www.hosted-in-luxembourg.lu/fr/">
                  <img src={hostedInLuxembourgLogo} alt="" />
                </a>
              </div>
              <div>
                <a target="_blank" rel="noopener noreferrer" href="http://www.made-in-luxembourg.lu/">
                  <img src={madeInLuxembourgLogo} alt="" />
                </a>
              </div>
              <div>
                <div className="product-by-zap">
                  <div>{this.props.translations['footer.aProductBy']}</div>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.zap.lu/">
                    <img src={zapLogo} alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div className="u-mt-4 legal-container">
              <span role="presentation" >
                <a
                  href="https://static.squareboard.cloud/plaquette_squareboard.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.translations['contact.downloadBrochure']}
                </a>
              </span>
              <span
                className="u-ml-4"
                role="presentation"
                onClick={() => {
                  this.props.history.push('/legal', { legal: 'terms' });
                }}
              >
                Terms and conditions
              </span>
              <span
                className="u-ml-4"
                role="presentation"
                onClick={() => {
                  this.props.history.push('/privacy', { legal: 'privacy' });
                }}
              >
                Privacy policy
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterView;
